module.exports = __webpack_public_path__ + "media/customizations/cotavera/logo-new-772281c8ff47e03551c423bf7787188e.png";